import { Globe } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function ApiRequestNode({ id, data, selected }) {
  const method = data.method || 'GET';
  const summary = data.url ? `${method} ${data.url}` : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.integrations}
      icon={Globe}
      label={data.label}
    >
      <p className="text-xs text-gray-500 truncate">{summary || data.description}</p>
    </BaseNode>
  );
}
